import type { Accent } from '../types/accent';
export interface Volume {
  code: string;
  name: string;
  count: string;
  accent: Accent;
  intro: string[];
  solves: string;
  result: string[];
}
export const volumes: Volume[] = [{
  code: '01',
  name: 'Fondamenti & Prime Sedute',
  count: '12 sessioni da 60 minuti',
  accent: 'pine',
  intro: ['Movimento, controllo della palla, passaggio, ricezione, palleggio e tiro, mostrati con sequenze visuali e diagrammi di campo.'],
  solves: 'Sguardo sulla palla, perdita di controllo in movimento e fondamentali scollegati.',
  result: ['Basi solide e 12 sedute pronte per trasformare i fondamentali in azioni collegate.']
}, {
  code: '02',
  name: 'Passaggio, Ricezione & Tiro',
  count: '12 sessioni da 60 minuti',
  accent: 'olive',
  intro: ['Precisione, timing e continuità: passare e ricevere in movimento e collegare il possesso al tiro.'],
  solves: 'Passaggi imprecisi, giocatori fermi dopo il passaggio e ricezioni poco orientate.',
  result: ["Giocatori che ricevono, si orientano e arrivano al tiro con continuità."]
}, {
  code: '03',
  name: '1 Contro 1 & Creazione dello Spazio',
  count: '12 sessioni da 60 minuti',
  accent: 'rust',
  intro: ['Cambi di direzione, finte, protezione della palla e lettura del difensore, fino all\'1 contro 1 guidato.'],
  solves: "Giocatori prevedibili e difficoltà nel superare l'avversario.",
  result: ['Tecnica individuale trasformata in situazioni reali di 1 contro 1.']
}, {
  code: '04',
  name: 'Difesa & Portiere',
  count: '12 sessioni da 60 minuti',
  accent: 'ember',
  intro: ["Posizione, spostamento, lettura dell'attaccante, collaborazione e introduzione al lavoro del portiere."],
  solves: 'Distanze sbagliate, spostamenti in ritardo e poca organizzazione tra difesa e porta.',
  result: ['Una progressione chiara dalla difesa individuale a quella collettiva.']
}, {
  code: '05',
  name: 'Collaborazioni & Gioco Collettivo',
  count: '12 sessioni da 60 minuti',
  accent: 'navy',
  intro: ['Passaggio e movimento, occupazione dello spazio, sostegno e collaborazioni progressive con i compagni.'],
  solves: 'Giocatori fermi dopo il passaggio, spazi occupati male e azioni isolate.',
  result: ['Gesti individuali trasformati in azioni coordinate tra più giocatori.']
}, {
  code: '06',
  name: 'Pianificazione & Organizzazione della Squadra',
  count: '12 sessioni da 60 minuti',
  accent: 'charcoal',
  intro: ['Obiettivi, progressioni, gruppi e spazi organizzati per costruire allenamenti e settimane con continuità.'],
  solves: "Sedute scollegate ed esercizi scelti all'ultimo momento.",
  result: ['Una struttura per sapere cosa allenare oggi e quale passo costruire dopo.']
}];
